<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <PageTitle :title="pageText.pageTitle" :subtitle="pageText.formText" showIcon />
      <div class="settings_menu profile_menu"></div>
      <div class="settings_menu">
        <!-- <div class="menu_title">Settings</div> -->
        <div>
          <!-- <a id="goToAboutPage" target="_blank" hidden href="https://locumate.com.au/about/"></a> -->
          <!-- <a id="goToPrivacyPolicyPage" target="_blank" hidden href="https://healthshifts.ai/privacy-policy/"></a> -->
          <el-button type="transparent" class="menu_item" @click="links.goToAbout">
            <!-- <span class="locumate_icons locumate_icon-question_circle"></span> -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17 18.4301H13L8.54999 21.39C7.88999 21.83 7 21.3601 7 20.5601V18.4301C4 18.4301 2 16.4301 2 13.4301V7.42999C2 4.42999 4 2.42999 7 2.42999H17C20 2.42999 22 4.42999 22 7.42999V13.4301C22 16.4301 20 18.4301 17 18.4301Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M12.0001 11.36V11.15C12.0001 10.47 12.4201 10.11 12.8401 9.82001C13.2501 9.54001 13.66 9.18002 13.66 8.52002C13.66 7.60002 12.9201 6.85999 12.0001 6.85999C11.0801 6.85999 10.3401 7.60002 10.3401 8.52002"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M11.9955 13.75H12.0045" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="text_wrapper">
              <div class="main_text">About</div>
              <div class="additional_text">Learn more about {{ $filters.appName() }}</div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" @click="links.goToTermsAndConditions">
            <!-- <span class="locumate_icons el-icon-document"></span> -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="rgb(var(--locumate-primary-color))"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7 13H13" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M7 17H11" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <div class="text_wrapper">
              <div class="main_text">Terms and Conditions</div>
              <div class="additional_text">Read terms and conditions</div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" @click="links.goToPrivacyPolicy">
            <!-- <span class="locumate_icons el-icon-document-checked"></span> -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 12.2002H15" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M8 16.2002H12.38" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M16 4.01953C19.33 4.19953 21 5.42953 21 9.99953V15.9995C21 19.9995 20 21.9995 15 21.9995H9C4 21.9995 3 19.9995 3 15.9995V9.99953C3 5.43953 4.67 4.19953 8 4.01953"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Privacy Policy</div>
              <div class="additional_text">Read privacy policies</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
    </div>
  </div>
</template>

<script>
import {
  // ref,
  // reactive,
  onMounted,
  inject,
  getCurrentInstance
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import {
  useRouter,
  // useRoute
} from "vue-router";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';


export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    PageTitle,
    SvgIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    // const $route = useRoute()
    const setPageClassGlobal = inject("setPageClassGlobal");
    const mainMenuShow = inject("mainMenuShow");
    const isAustralia = isAustraliaRegion();
    const isUs = isUSRegion();
    const instance = getCurrentInstance();

    const user = $store.getters.GET_USER_DATA;

    const links = {
      goToAbout: () => {

        if(isAustralia.value){
          window.open("https://locumate.com.au/about/", "_blank");
          // const link = document.getElementById("goToAboutPage");
          // link.click();
        }else{
          window.open("https://healthshifts.ai", "_blank");
        }
     
      },

      goToTermsAndConditions: () => {
        $router.push({
          name: "terms_and_conditions",
        });
      },
      goToPrivacyPolicy: () => {
       
        if(isAustralia.value){
          $router.push({
            name: "privacy_policy",
          });
        }else{
          window.open("https://healthshifts.ai/privacy-policy/", "_blank");
        }
        // const link = document.getElementById("goToPrivacyPolicyPage");
        // link.click();
      },
    };

    const goBack = () => {
      if(isUs){
        if (instance?.appContext.config.globalProperties.$filters.employerType(user)) {
          $router.push({
            name: "profile",
          });
        }else{
          $router.push({
            name: "my_profile",
          });
        }
      }
      if(isAustralia){
        if(instance?.appContext.config.globalProperties.$filters.employerType(user).isCommunityPharmacy){
          $router.push({
            name: "profile",
          });
        }else{
          $router.push({
            name: "my_profile",
          });
        }
      }
    };
    onMounted(() => {
      setPageClassGlobal("global_profile_page");
      mainMenuShow(true);
    });
    const pageText = {
      pageTitle: 'About',
      formText: '',
    }
    return {
      user,
      // environment,
      goBack,
      links,
      pageText,
      isAustralia,
      isUs,
      instance
    };
  },
};
</script>
